export default __webpack_public_path__ + "static/media/person-holding-phone-au-2.4cca21e9.png";